"use strict";

exports.__esModule = true;
exports.calculateElementPathAfterDelete = calculateElementPathAfterDelete;
/**
 * Calculate the path to an element after the element at the given path has been deleted.
 */
function calculateElementPathAfterDelete(path, deleted) {
  if (deleted.length > path.length) {
    return path;
  }
  var recalculated = [];
  for (var i = 0; i < path.length; i++) {
    if (i >= deleted.length) {
      recalculated.push.apply(recalculated, path.slice(i));
      break;
    }
    var item = path[i];
    var deletedItem = deleted[i];
    if (typeof deletedItem === "number" && typeof item === "number") {
      if (deletedItem > item) {
        recalculated.push.apply(recalculated, path.slice(i));
        break;
      }
      if (deletedItem < item) {
        recalculated.push.apply(recalculated, [item - 1].concat(path.slice(i + 1)));
        break;
      }
    }
    recalculated.push(item);
  }
  return recalculated;
}